import { createContext } from "react";

// Create the context
const TokenContext = createContext(null);

// Export the context's Consumer for class components
export const TokenConsumer = TokenContext.Consumer;

export default TokenContext;
